var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1192 27.0713C12.8219 28.2421 10.6789 29.919 8.19977 30.3924C8.19977 30.3924 10.1332 27.7181 10.1332 24.6391C10.1332 24.6391 3.75475 22.6949 4.1342 15.4347C4.1342 15.4347 4.74494 4.82449 18.9329 5.68819C27.8301 6.23027 30.0924 10.3826 30.7031 13.3459",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.409 16.9273C12.2552 16.9273 12.9412 16.2413 12.9412 15.3951C12.9412 14.5488 12.2552 13.8628 11.409 13.8628C10.5627 13.8628 9.87671 14.5488 9.87671 15.3951C9.87671 16.2413 10.5627 16.9273 11.409 16.9273Z",
    stroke: "#27C3E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1863 16.7214C15.8899 16.2769 15.8177 15.4529 16.4175 14.853C17.0174 14.2531 17.8269 14.2423 18.2209 14.5784",
    stroke: "#276AE2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7454 30.5078L33.8868 36.6224",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8703 31.5848C29.5666 31.5848 33.3737 27.7778 33.3737 23.0815C33.3737 18.3852 29.5666 14.5781 24.8703 14.5781C20.174 14.5781 16.3669 18.3852 16.3669 23.0815C16.3669 27.7778 20.174 31.5848 24.8703 31.5848Z",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_3005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchChatIcon);
export default __webpack_public_path__ + "static/media/SearchChatIcon.5b86c7ee8782d5741f070979abbcc2af.svg";
export { ForwardRef as ReactComponent };